import { useAuthContext } from '../../../contexts/AuthContext'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { TestSendForm, TestPageHeader } from '../../../components/alerts/TestSendForm'
import { alertsApi } from '../../../services/admin/alertsApi'
import { LocalStorageItem } from '../../../common/constants'

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export default function PipelineEmailTestPage() {
  const { email } = useAuthContext()
  return (
    <div className="space-y-6">
      <TestPageHeader
        mode="pipeline"
        title="Pipeline Email"
        subtitle={
          <>
            Inserts a row into <span className="font-mono text-gray-700">active_alerts</span> flagged
            as a test. The processor polls every 30 seconds, sends via SendGrid, and writes to{' '}
            <span className="font-mono text-gray-700">alert_notifications</span>. Validates the full
            DB → processor → send chain.
          </>
        }
      />

      <section className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <TestSendForm
          mode="pipeline"
          recipientLabel="Recipient"
          recipientType="email"
          recipientPlaceholder="name@example.com"
          recipientRegex={EMAIL_REGEX}
          recipientInvalidMessage="Enter a valid email address."
          bodyRows={4}
          defaultBody={`This is a pipeline test email from the IoAg admin portal${email ? ` (by ${email})` : ''}.\n\nIf you received this, the full alerts pipeline (DB → processor → SendGrid) is healthy.`}
          storageKey={LocalStorageItem.adminTestEmailRecipient}
          buttonLabel="Insert Pipeline Alert"
          buttonIcon={faEnvelope}
          bodyHelper="Test rows are marked isTest=true and excluded from customer-facing reporting."
          onSend={async (params) => {
            const r = await alertsApi.pipelineEmail(params)
            return {
              recipient: r.recipient,
              detail: `Row #${r.activeAlertId} inserted. Processor polls every ~${r.estimatedDeliverySeconds}s — check the Log shortly.`,
            }
          }}
        />
      </section>
    </div>
  )
}
